// Environnement et version
export const ENV = process.env.REACT_APP_ENV || "LOCAL";
export const version = process.env.REACT_APP_VERSION || "v. 26/06/2026";

// Back nestjs Supervision
export const ROOT_URL_SUPVISION_BACK = process.env.REACT_APP_ROOT_URL_SUPERVISION_BACK;

// Middleware
export const ROOT_URL_MIDDLEWARE = process.env.REACT_APP_ROOT_URL_MIDDLEWARE;
export const MIDDLEWARE_BEARER_TOKEN = process.env.REACT_APP_MIDDLEWARE_BEARER_TOKEN;
